

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const BULKUPLOADEMPLOYEEFROMEXCEL= createAsyncThunk(
  "bulkUploadEmployeeFromExcel/bulkUploadEmployeeFromExcel",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const bulkUploadEmployeeFromExcelSlice = createSlice({
  name: "bulkUploadEmployeeFromExcelSlice",
  initialState: {
    bulkUploadEmployeeFromExcel: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfbulkUploadEmployeeFromExcel: (state) => {
        state.bulkUploadEmployeeFromExcel.loading = false
        state.bulkUploadEmployeeFromExcel.error = false
        state.bulkUploadEmployeeFromExcel.data = []
        state.bulkUploadEmployeeFromExcel.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(BULKUPLOADEMPLOYEEFROMEXCEL.fulfilled, (state, action) => {
      state.bulkUploadEmployeeFromExcel = {
        ...state.bulkUploadEmployeeFromExcel,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADEMPLOYEEFROMEXCEL.pending, (state, action) => {
      state.bulkUploadEmployeeFromExcel = {
        ...state.bulkUploadEmployeeFromExcel,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADEMPLOYEEFROMEXCEL.rejected, (state, action) => {
      state.bulkUploadEmployeeFromExcel = {
        ...state.bulkUploadEmployeeFromExcel,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const bulkUploadEmployeeFromExcelAction = {
    BULKUPLOADEMPLOYEEFROMEXCEL,
};

export { bulkUploadEmployeeFromExcelAction };
export default bulkUploadEmployeeFromExcelSlice.reducer;
export const {setInitialStateOfbulkUploadEmployeeFromExcel} = bulkUploadEmployeeFromExcelSlice.actions
